import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
export const bomMetricsFilterSchema = z.object({
    brandId: optionalUuidString('Invalid brand selection.').nullish(),
    locationGroupId: optionalUuidString('Invalid warehouse selection.').nullish(),
});
//# sourceMappingURL=metrics-filter.js.map